import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
});

// Mensaje del backend para mostrar al usuario (las reglas de negocio vienen en { message })
export const errorMessage = (error, fallback = 'Ocurrió un error, intenta de nuevo.') =>
    error?.response?.data?.message || fallback;

// --- Administrador ---

export const searchContracts = async (page, limit, filters = {}) => {
    const response = await axios.get(`${apiUrl}/contracts`, {
        params: { page, limit, ...filters },
        headers: authHeaders(),
    });
    return response.data;
};

export const getUserContracts = async (email) => {
    const response = await axios.get(`${apiUrl}/contracts/user/${encodeURIComponent(email)}`, { headers: authHeaders() });
    return response.data;
};

export const createContract = async (body) => {
    const response = await axios.post(`${apiUrl}/contracts`, body, { headers: authHeaders() });
    return response.data;
};

export const registerPayment = async (id, validUntil) => {
    const response = await axios.post(`${apiUrl}/contracts/${id}/payment`, { validUntil }, { headers: authHeaders() });
    return response.data;
};

// Vacío quita el vendedor
export const changeContractSeller = async (id, sellerEmail) => {
    const response = await axios.put(`${apiUrl}/contracts/${id}/seller`, { sellerEmail: sellerEmail || null },
        { headers: authHeaders() });
    return response.data;
};

export const suspendContract = async (id) => {
    const response = await axios.post(`${apiUrl}/contracts/${id}/suspend`, null, { headers: authHeaders() });
    return response.data;
};

export const reactivateContract = async (id) => {
    const response = await axios.post(`${apiUrl}/contracts/${id}/reactivate`, null, { headers: authHeaders() });
    return response.data;
};

export const endContract = async (id) => {
    const response = await axios.post(`${apiUrl}/contracts/${id}/end`, null, { headers: authHeaders() });
    return response.data;
};

export const convertContract = async (id, body) => {
    const response = await axios.post(`${apiUrl}/contracts/${id}/convert`, body, { headers: authHeaders() });
    return response.data;
};

export const setLoanerUnit = async (sensorId, loaner) => {
    const response = await axios.put(`${apiUrl}/contracts/loaner-units/${encodeURIComponent(sensorId)}`, { loaner },
        { headers: authHeaders() });
    return response.data;
};

export const runExpirations = async () => {
    const response = await axios.post(`${apiUrl}/contracts/run-expirations`, null, { headers: authHeaders() });
    return response.data;
};

// --- Usuario autenticado ---

export const getMyContracts = async () => {
    const response = await axios.get(`${apiUrl}/contracts/me`, { headers: authHeaders() });
    return response.data;
};

// --- Vendedor (y admin) ---

export const getLoanerUnits = async () => {
    const response = await axios.get(`${apiUrl}/seller/loaner-units`, { headers: authHeaders() });
    return response.data;
};

export const getTrials = async () => {
    const response = await axios.get(`${apiUrl}/seller/trials`, { headers: authHeaders() });
    return response.data;
};

export const startTrial = async (body) => {
    const response = await axios.post(`${apiUrl}/seller/trials`, body, { headers: authHeaders() });
    return response.data;
};

export const extendTrial = async (id, days) => {
    const response = await axios.post(`${apiUrl}/seller/trials/${id}/extend`, { days }, { headers: authHeaders() });
    return response.data;
};

export const endTrial = async (id) => {
    const response = await axios.post(`${apiUrl}/seller/trials/${id}/end`, null, { headers: authHeaders() });
    return response.data;
};

export const changeProspectPassword = async (email, password) => {
    const response = await axios.put(`${apiUrl}/seller/prospects/${encodeURIComponent(email)}/password`,
        { password }, { headers: authHeaders() });
    return response.data;
};
